// src/lib/auditLogView.ts

export type AuditLogRow = {
  id: string;
  createdAt: string; // ISO
  entityType: string;
  entityId: string | null;
  action: string;
  message: string | null;

  actorUserId: string | null;
  actorName: string | null;
  actorEmail: string | null;
  actorRole: string | null;

  before: any;
  after: any;
  diff: any;
  meta: any;
};

export type AuditLogViewModel = {
  id: string;
  createdAt: Date;
  timeLabel: string; // "2/28/2026, 10:13 AM"
  actorLabel: string; // "Jane Doe (ORG_ADMIN)" or "Unknown"
  actionLabel: string; // "Updated"
  entityLabel: string; // "Customer"
  message: string;
  diffPretty: Array<{ field: string; before: any; after: any }>;
  raw: AuditLogRow;
};

function safeToString(v: any) {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
}

export function formatValue(v: any) {
  if (v == null) return '—';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  // for arrays/objects keep it readable
  const s = safeToString(v);
  return s.length > 180 ? s.slice(0, 180) + '…' : s;
}
